import { Section, highlight } from "./shared";

export function OneMinuteRevisionSection({ items, regex }) {
  if (!items?.length) return null;
  return (
    <Section label="One-Minute Revision">
      <ol className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5">
        {items.map((r, i) => (
          <li key={i} className="text-sm flex gap-2 items-start">
            <span className="font-mono text-[10px] text-[#3B82F6] mt-1 flex-shrink-0 w-4">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span>{highlight(r, regex)}</span>
          </li>
        ))}
      </ol>
    </Section>
  );
}

export function ExamQuestionsSection({ questions, regex }) {
  if (!questions?.length) return null;
  return (
    <Section label="Possible Exam Questions">
      <ol className="space-y-2">
        {questions.map((q, i) => (
          <li key={i} className="text-sm flex gap-2 items-start">
            <span className="font-mono text-[10px] text-zinc-400 mt-1 flex-shrink-0 w-5">Q{i + 1}</span>
            <span className="flex-1">
              {highlight(q.question, regex)}
              {q.type && (
                <span className="ml-2 font-mono text-[9px] uppercase tracking-widest bg-black text-white px-1.5 py-0.5">
                  {q.type}
                </span>
              )}
            </span>
          </li>
        ))}
      </ol>
    </Section>
  );
}
